import { useEffect } from "react";
import {
  getDynamicComponentId,
  getDynamicComponentVendorId,
} from "@companion-core/shared/app/Utils/tracking";
import { ContentDetailsPageHookProps } from "@companion-core/shared/app/Components/DetailsPages/ContentDetailsPage/ContentDetailsPage.model";
import { UseQueryResult } from "@tanstack/react-query";
import { APIContentComponent, APIVendorComponent } from "@companion-core/shared/app/Interfaces/API";
import { useDetailPage } from "@companion-core/shared/app/Queries/detailPage";
import { trackDynamicPage } from "@companion-core/shared/app/tracking/dynamicPage";
import { useDetailsPage } from "@companion-core/shared/app/Components/DetailsPages/hooks/detailsPage";

export const useContentDetailsPage = ({
  id,
  pageSlug,
  contentType,
}: ContentDetailsPageHookProps) => {
  const { lang } = useDetailsPage();
  const {
    data,
    isFetching,
    isPending,
  }: UseQueryResult<(APIContentComponent & APIVendorComponent) | null, unknown> = useDetailPage<
    APIContentComponent & APIVendorComponent
  >({
    parentID: id ?? "",
    lang,
    contentType: contentType ?? "",
  });

  useEffect(() => {
    if (data) {
      trackDynamicPage({
        pageSlug,
        family: data.family ?? data.vendor?.family,
        subfamily: data.subfamily ?? data.vendor?.subfamily ?? undefined,
        contentId: getDynamicComponentId(data),
        vendorId: getDynamicComponentVendorId(data),
      });
    }
  }, [data]);

  return {
    lang,
    data,
    isFetching,
    isPending,
    isError: data === null,
  };
};
